<template>
	<div>
		<div class="tr h">
			<div class="play">玩法</div>
			<div class="bets">投注</div>
			<div class="mul">倍数/金额</div>
		</div>
		<div class="tr" v-for="(item, index) in matchList.list" :key="index">
			<div class="play">{{changeType(item.type)}}</div>
			<div class="bets">
				<div class="ball-line" v-if="item.type != 3">
					<div class="ball red" v-for="(ii,tt) in item.front">{{ii}}</div>
					<div class="ball blue" v-for="(ii,tt) in item.back">{{ii}}</div>
				</div>
				<div class="ball-line" v-if="item.type == 3">
					<div class='tt' v-if="item.front_d.length!=0">前胆</div>
					<div class="ball red" v-for="(ii,tt) in item.front_d">{{ii}}</div>
					<div class='tt' v-if="item.front_t.length!=0">前拖</div>
					<div class="ball red" v-for="(ii,tt) in item.front_t">{{ii}}</div>
					<div class='tt' v-if="item.back_d.length!=0">后胆</div>
					<div class="ball blue" v-for="(ii,tt) in item.back_d">{{ii}}</div>
					<div class='tt' v-if="item.back_t.length!=0">后拖</div>
					<div class="ball blue" v-for="(ii,tt) in item.back_t">{{ii}}</div>
				</div>
			</div>
			<div class="mul">{{item.mul}}倍/{{item.mul * item.count * 2}}元</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['matchList'],
		name:"luckyTable",
		data() {
			return {
				
			};
		},
		methods:{
			changeType(_t){
				switch(_t){
					case 1 : return '单式';
					case 2 : return '复式';
					case 3 : return '胆拖';
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.tr {
		display: flex; flex-direction: row; align-items: center;
		border-bottom: solid 1px #ECECEC;
		font-size: 12px;
		.play {
			width: 70px;
			
			display: flex; flex-direction: row; align-items: center;justify-content: center;
			padding: 5px;
			color: #555555;
		}
		.bets {
			width: 300px;
			margin-right: 1px;
			border-left: solid 1px #ECECEC;
			border-right: solid 1px #ECECEC;
			display: flex; flex-direction: row; align-items: center;justify-content: center;
			flex-wrap: wrap;
			padding: 5px;
			color: #666666;
			font-size: 12px;
			.ball {
				padding: 2px;
			}
			.red {
				color: #EB4C37;
				width: 24px;
				height: 12px;
				line-height: 12px;
				text-align: center;
				font-size: 12px;
				border: solid 1px #EB4C37;
				border-radius: 12px;
				margin: 1px;
			}
			.tt {
				margin:0 2px;
			}
			.blue {
				color: #3399ff;
				width: 24px;
				height: 12px;
				line-height: 12px;
				text-align: center;
				font-size: 12px;
				border: solid 1px #3399ff;
				border-radius: 12px;
				margin: 1px;
			}
			.ball-line {
				display: flex; flex-direction: row; align-items: center; flex-wrap: wrap;
				justify-content: center;
			}
		}
		.mul {
			width: 80px;
			display: flex; flex-direction: row; align-items: center;justify-content: center;
			padding: 5px;
		}
	}
	.h {
		font-size: 12px;
		background-color: #ECECEC;
	}
</style>